import { useRouteError } from "react-router";

import ErrorBoundary from "@/modules/error-boundary";

const RouterErrorBoundary = () => {
  const error = useRouteError();

  return <ErrorBoundary error={error} />;
};

export default RouterErrorBoundary;
